import { FilterOutlined } from "@ant-design/icons";
import { Button, Space } from "antd";
import { FC, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "store/Reducers";

const ScrollButton: FC<{ options: any[],isMobile:boolean }> = ({ options,isMobile }) => {
  const [isFixed, setIsFixed] = useState(true);
  const [isHidden, setIsHidden] = useState(false);
  const { filter } = useSelector((state: RootState) => state.realState);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const targetPosition = 400;
      const hidePosition = 800;

      if (scrollY < targetPosition) {
        setIsFixed(true);
        setIsHidden(false);
      } else if (scrollY >= targetPosition && scrollY < hidePosition) {
        setIsFixed(false);
        setIsHidden(false);
      } else {
        setIsHidden(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const setFixedPostion = () => {
  
    if (filter?.CategoryId) {
     
      return isFixed && (options?.length > 0 || filter?.categoryContainer*9 > 200)
        ? `fixed bottom-10  right-10 ${isMobile?"left-19":"left-20"}`
        : "relative left-18";
    } else {
      return "";
    }
  };


  return (
    <Button
      htmlType="submit"
      className={`!bg-[#FFC502] p-3 !text-black ${isMobile?"!w-[300px]":"!w-[250px]"} !z-9999 rounded-md transition-all !mt-4 ${
        isHidden ? "opacity-0 pointer-events-none" : "opacity-100"
      } ${setFixedPostion()}`}
    >
      <Space>
        <FilterOutlined className="!text-black" />
        <span>Filtrele</span>
      </Space>
    </Button>
  );
};

export default ScrollButton;
